module.exports = __webpack_public_path__ + "img/area-comum-17.a3999ecc.png";